import ManualPaymentHandlingDescription from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling_description.mdx";
import ManualPaymentHandlingOnTokenizeSuccess from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling_onTokenizeSuccess.mdx";
import ManualPaymentHandlingOnTokenizeError from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling_onTokenizeError.mdx";
import ManualPaymentHandlingOnResumeSuccess from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling_onResumeSuccess.mdx";
import ManualPaymentHandlingOnResumeError from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling_onResumeError.mdx";
import TokenizationCallbacksOnTokenizeDidNotStart from "../../../../content/sdk/web/2.x.x/_common/tokenizationCallbacks_onTokenizeDidNotStart.mdx";
import TokenizationCallbacksOnTokenizeShouldStart from "../../../../content/sdk/web/2.x.x/_common/tokenizationCallbacks_onTokenizeShouldStart.mdx";
import TokenizationCallbacksOnTokenizeStart from "../../../../content/sdk/web/2.x.x/_common/tokenizationCallbacks_onTokenizeStart.mdx";
import * as React from 'react';
export default {
  ManualPaymentHandlingDescription,
  ManualPaymentHandlingOnTokenizeSuccess,
  ManualPaymentHandlingOnTokenizeError,
  ManualPaymentHandlingOnResumeSuccess,
  ManualPaymentHandlingOnResumeError,
  TokenizationCallbacksOnTokenizeDidNotStart,
  TokenizationCallbacksOnTokenizeShouldStart,
  TokenizationCallbacksOnTokenizeStart,
  React
};